import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { downloadFile } from 'resources/images/common';

interface Props {
    url: string;
    icon?: string;
    image?: string;
    label?: string;
    qa?: string;
}

const DownloadFile = (props: Props) => {
    const { t } = useTranslation();

    return (
        <a key={props.url} target="_blank" href={props.url} rel="noopener noreferrer">
            {!props.image && (
                <Row className="planner-download-file" data-qa={props.qa} align="middle">
                    <Row className="planner-download-file-icon" align="middle">
                        <Row>
                            <img src={props.icon} alt="planner-download-file-icon" />
                        </Row>
                        <Row>{props.label && <span>{props.label}</span>}</Row>
                    </Row>
                    <Row className="planner-download-file-download-icon" align="middle">
                        <Row>
                            <Col>
                                <img src={downloadFile} alt="planner-download-file-download-icon" />
                            </Col>
                            <Col>{t('common.downloadFile')}</Col>
                        </Row>
                    </Row>
                </Row>
            )}
            {props.image && (
                <Row className="planner-download-file" data-qa={props.qa} align="middle">
                    <img className="planner-download-file-download-image" src={props.image} alt={props.image} />
                </Row>
            )}
        </a>
    );
};

export default DownloadFile;
